import { faBuilding, faCartShopping, faFileInvoiceDollar, faFilePdf, faMoneyBillTrendUp } from "@fortawesome/free-solid-svg-icons"
import MenuItem from "../../../types/menu/MenuItem"

const GLFNavListInternal: MenuItem[] = [
  {
    id: 1,
    name: 'summaryReview',
    componentName: 'Summary',
    complete: false,
    icon: faFilePdf
  },
  {
    id: 2,
    name: 'contactInfo',
    componentName: 'ContactInfo',
    complete: false
  },
  {
    id: 3,
    name: 'incomeExpense',
    componentName: 'IncomeExpense',
    complete: false,
    icon: faMoneyBillTrendUp,
    subItems: [
      {
        id: 31,
        name: 'roundsRate',
        complete: false,
        componentName: 'RoundsRate'
      },
      {
        id: 32,
        name: 'revenue',
        componentName: 'RevenueContainer',
        hasTabs: true,
        complete: false,
        subItems: [
          {
            id: 321,
            name: 'GLF.revenue',
            complete: false
          },
          {
            id: 322,
            name: 'GLF.sales',
            complete: false
          },
          {
            id: 323,
            name: 'GLF.nonOperatingIncomeRevenues',
            complete: false
          }
        ]
      },
      {
        id: 33,
        name: 'expenses',
        componentName: 'ExpenseContainer',
        hasTabs: true,
        complete: false,
        subItems: [
          {
            id: 331,
            name: 'GLF.cost',
            complete: false
          },
          {
            id: 332,
            name: 'GLF.expense',
            complete: false
          },
          {
            id: 333,
            name: 'GLF.managementFees',
            complete: false
          },
          {
            id: 333,
            name: 'GLF.charges',
            complete: false
          },
          {
            id: 334,
            name: 'GLF.nonOperatingIncomeExpenses',
            complete: false
          }
        ]
      },
      {
        id: 34,
        name: 'GLF.reserve',
        componentName: 'IncomeAttributeTable',
        complete: false
      },
      {
        id: 35,
        name: 'capitalExpSummary',
        componentName: 'CapitalCostContainer',
        complete: false,
        hasTabs: true,
        subItems: [
          {
            id: 351,
            name: 'GLF.course',
            complete: false
          },
          {
            id: 352,
            name: 'GLF.building',
            complete: false
          },
        ]
      },
      {
        id: 36,
        name: 'analysis',
        componentName: 'Analysis',
        complete: false
      }
    ],
  },
  {
    id: 4,
    name: 'apartment',
    complete: false,
    icon: faBuilding,
    subItems: [
      {
        id: 41,
        name: 'suiteBreakdownTable',
        componentName: 'SuiteBreakdown',
        complete: false
      }
    ]
  },
  {
    id: 5,
    name: 'commercial',
    complete: false,
    icon: faCartShopping,
    subItems: [
      {
        id: 51,
        name: 'leaseInformationTable',
        componentName: 'LeaseInfo',
        complete: false
      },
      {
        id: 52,
        name: 'vacantAskingRate',
        complete: false,
        componentName: 'VacantAskingRate',
      },
      {
        id: 53,
        name: 'parkingSummary',
        complete: false,
        componentName: 'ParkingPropertySummary',
      }
    ]
  },
  {
    id: 6,
    name: 'comments',
    componentName: 'Comment',
    complete: false
  },
  {
    id: 7,
    name: 'submit',
    componentName: 'Submit',
    complete: false,
    icon: faFileInvoiceDollar
  }
]

export default GLFNavListInternal